import React from "react";
import { TwoButton } from "../../components/attributes/Button";
import TemplateModal from "../../components/template/Template.Modal";
import {
  CONSTANT_LANGUAGE,
  CONSTANT_LANGUAGE_FULL,
  CONSTANT_LANGUAGE_IMAGE_DRAWER,
  CONSTANT_LANGUAGE_IMAGE_MODAL,
  TEXT_CANCEL,
  TEXT_CONFIRM,
} from "../../utils/useConstants";
import { ICON_ENGLISH, ICON_THAI, ICON_X } from "../../utils/useIcons";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_BG_MODAL,
  STYLE_BG_OPACITY_MODAL,
  STYLE_BG_TRANSPARENT_MODAL,
  STYLE_BG_WHITE_DRAWER_INFO,
  STYLE_BUTTON_BLUE_MODAL_LANGUAGE,
  STYLE_BUTTON_CANCEL_MODAL_LANGUAGE,
  STYLE_HEADING_3,
  STYLE_HEADING_3_TH,
  STYLE_IMG_LANGUAGE,
  STYLE_PARENT_MODAL,
  STYLE_PARENT_PANEL_MODAL,
  STYLE_PREPARE_LANGUAGE,
  STYLE_SUBTITLE_BOLD,
  STYLE_TITLE_MENU,
  STYLE_UNSELECT_LANGUAGE,
} from "../../utils/useStyle";
import {
  ContextLanguage,
  FunctionClickIsNotPageSaparate,
} from "../Context.Language";
import { FunctionChangeHerfLanguage } from "../../utils/useFunction";
import { useLocation } from "react-router-dom";

const Eng = ({ setPrepair, prepair, setLanguageIn }) => {
  return (
    <div
      className={`${STYLE_PARENT_MODAL} ${
        "EN" === prepair ? STYLE_PREPARE_LANGUAGE : STYLE_UNSELECT_LANGUAGE
      } mb-3 `}
      onClick={(e) => {
        e.stopPropagation();
        setPrepair("EN");
        setLanguageIn("EN");
      }}
    >
      <div
        className={`text-base md:text-lg leading-6  cursor-pointer flex gap-3 md:gap-4 items-center font-Poppins`}
      >
        {CONSTANT_LANGUAGE_IMAGE_MODAL.EN}
        {CONSTANT_LANGUAGE_FULL.EN}
      </div>
    </div>
  );
};

const Th = ({ setPrepair, row, prepair, setLanguageIn }) => {
  const isMobile = useIsMobile();
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        setPrepair("TH");
        setLanguageIn("TH");
      }}
      className={`${STYLE_PARENT_MODAL} ${
        "TH" === prepair ? STYLE_PREPARE_LANGUAGE : STYLE_UNSELECT_LANGUAGE
      } ${isMobile ? "  " : " mb-6 "}`}
    >
      <div
        className={`text-base-th md:text-lg-th leading-6  cursor-pointer flex gap-3 md:gap-4 items-center font-NotoSansThai`}
      >
        {CONSTANT_LANGUAGE_IMAGE_MODAL.TH}
        <div className="-mb-1"> {CONSTANT_LANGUAGE_FULL.TH}</div>
      </div>
    </div>
  );
};

// const ContextRenderChangeLanguage = ({ text, drawer }) => {
//   const [open, setOpen] = React.useState(false);
//   const { language, FunctionChangeLanguageTo } =
//     React.useContext(ContextLanguage);
//   const [prepair, setPrepair] = React.useState(language);
//   const isMobile = useIsMobile();
//   const [languageIn, setLanguageIn] = React.useState(language);

//   React.useEffect(() => {
//     setPrepair(language);
//     setLanguageIn(language);
//   }, [setPrepair, setLanguageIn, language]);

//   return (
//     <div className="relative">
//       <div
//         onClick={(e) => {
//           e.stopPropagation();
//           setOpen(!open);
//         }}
//         className={`${
//           drawer ? "gap-2" : "gap-4"
//         } flex  items-center cursor-pointer`}
//       >
//         {drawer ? (
//           CONSTANT_LANGUAGE_IMAGE_DRAWER[language]
//         ) : (
//           <React.Fragment>
//             <div
//               style={{
//                 display: language === "TH" ? "block" : "none",
//               }}
//             >
//               <ICON_THAI className={STYLE_IMG_LANGUAGE} />
//             </div>
//             <div
//               style={{
//                 display: language === "EN" ? "block" : "none",
//               }}
//             >
//               <ICON_ENGLISH className={STYLE_IMG_LANGUAGE} />
//             </div>
//           </React.Fragment>
//         )}
//         {text ? (
//           <div className={STYLE_TITLE_MENU(language)}>
//             {CONSTANT_LANGUAGE_FULL[language]}
//           </div>
//         ) : (
//           ``
//         )}
//         {isMobile ? (
//           <div
//             onClick={() => setOpen(false)}
//             className={`${
//               open ? STYLE_BG_OPACITY_MODAL : STYLE_BG_TRANSPARENT_MODAL
//             } ${STYLE_BG_MODAL}`}
//           >
//             <div
//               className={`${
//                 open ? "h-full inset-0  " : " h-0 w-0 "
//               } transition-shadow  duration-500 fixed  `}
//             >
//               {open && (
//                 <React.Fragment>
//                   <div
//                     onClick={(e) => {
//                       e.stopPropagation();
//                     }}
//                     className={`${STYLE_BG_WHITE_DRAWER_INFO} `}
//                     // className={`${STYLE_BG_WHITE_DRAWER_INFO} w-full px-4.5 pt-4.5 `}
//                   >
//                     <div
//                       className={` bg-white rounded-t-xl h-13 z-10 p-4  md:p-6 fixed bottom-0 w-full  grid ${
//                         true ? " grid-cols-1 " : " grid-cols-2 "
//                       } gap-2 md:gap-6 "`}
//                     >
//                       <div
//                         className={`${STYLE_SUBTITLE_BOLD} ${
//                           language === "TH" ? " text-22-th " : " text-22 "
//                         } flex justify-between mb-5 h-8  `}
//                       >
//                         <div className="leading-8 font-Poppins ">
//                           {" "}
//                           Language •
//                           <span className=" font-NotoSansThai "> ภาษา</span>
//                         </div>
//                         <ICON_X
//                           className=" w-8 h-8 text-laudry-gray-200 "
//                           onClick={() => setOpen(false)}
//                         />
//                       </div>
//                       <div className=" flex flex-col justify-between  ">
//                         {Object.keys(CONSTANT_LANGUAGE).map((row, i) => {
//                           if (row === CONSTANT_LANGUAGE.TH) {
//                             return (
//                               <div
//                                 key={`key-of-language-${i}`}
//                                 className=" space-y-6"
//                               >
//                                 <Th
//                                   setPrepair={setPrepair}
//                                   row={row}
//                                   prepair={prepair}
//                                   setLanguageIn={setLanguageIn}
//                                 />
//                               </div>
//                             );
//                           } else if (row === CONSTANT_LANGUAGE.EN) {
//                             return (
//                               <div
//                                 key={`key-of-language-${i}`}
//                                 className=" space-y-6 "
//                               >
//                                 <Eng
//                                   setPrepair={setPrepair}
//                                   row={row}
//                                   prepair={prepair}
//                                   setLanguageIn={setLanguageIn}
//                                 />
//                               </div>
//                             );
//                           } else {
//                             return <React.Fragment />;
//                           }
//                         })}
//                         <div
//                           className={`pt-4 pb-6
//                         ${
//                           prepair === "TH"
//                             ? "font-NotoSansThai"
//                             : "font-Poppins"
//                         }`}
//                         >
//                           <TwoButton
//                             className={` grid grid-cols-2 w-full gap-4 `}
//                             onClickSecond={() => {
//                               FunctionChangeLanguageTo(prepair);
//                               setOpen(!open);
//                             }}
//                             onClickFirst={() => {
//                               setOpen(false);
//                             }}
//                             titlefirst={TEXT_CANCEL[languageIn]}
//                             titlesecond={TEXT_CONFIRM[languageIn]}
//                             classNameCancel={STYLE_BUTTON_CANCEL_MODAL_LANGUAGE(
//                               languageIn
//                             )}
//                             classNameAccept={`${STYLE_BUTTON_BLUE_MODAL_LANGUAGE(
//                               languageIn
//                             )}`}
//                           />
//                           {/* <BlueButton
//                           title={`Ok`}
//                           onClick={() => {
//                             FunctionChangeLanguageTo(prepair);
//                           }}
//                         /> */}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </React.Fragment>
//               )}
//             </div>
//           </div>
//         ) : (
//           <TemplateModal
//             classNameSave={`${
//               prepair === "TH"
//                 ? " text-sm-th md:text-base-th "
//                 : " text-sm md:text-base "
//             }`}
//             classNameCancel={`${
//               prepair === "TH"
//                 ? " text-sm-th md:text-base-th "
//                 : " text-sm md:text-base "
//             }`}
//             classNameModal={`${
//               prepair === "TH" ? "font-NotoSansThai" : "font-Poppins"
//             } h-modals`}
//             acceptText={TEXT_CONFIRM[languageIn]}
//             cancelText={TEXT_CANCEL[languageIn]}
//             save={() => {
//               FunctionChangeLanguageTo(prepair);
//             }}
//             showCloseButton={true}
//             showSaveButton={true}
//             open={open}
//             setOpen={setOpen}
//             panel={
//               <div
//                 onClick={(e) => {
//                   e.stopPropagation();
//                 }}
//                 className={STYLE_PARENT_PANEL_MODAL}
//               >
//                 <div
//                   className={`${
//                     language === "TH" ? STYLE_HEADING_3_TH : STYLE_HEADING_3
//                   } text-center mb-4 h-head_language `}
//                 >
//                   Language • <span className="font-NotoSansThai"> ภาษา</span>
//                 </div>

//                 {/* {Object.keys(CONSTANT_LANGUAGE).map((row, i) => {
//                   if (row === CONSTANT_LANGUAGE.EN) {
//                     return (
//                       <div key={`key-of-language-${i}`} className=" space-y-4">
//                         <Eng
//                           setPrepair={setPrepair}
//                           row={row}
//                           prepair={prepair}
//                           setLanguageIn={setLanguageIn}
//                         />
//                       </div>
//                     );
//                   } else if (row === CONSTANT_LANGUAGE.TH) {
//                     return (
//                       <div key={`key-of-language-${i}`} className=" space-y-4 ">
//                         <Th
//                           setPrepair={setPrepair}
//                           row={row}
//                           prepair={prepair}
//                           setLanguageIn={setLanguageIn}
//                         />
//                       </div>
//                     );
//                   } else {
//                     return <React.Fragment />;
//                   }
//                 })} */}
//                 <div className="">
//                   <Eng
//                     setPrepair={setPrepair}
//                     // row={row}
//                     prepair={prepair}
//                     setLanguageIn={setLanguageIn}
//                   />
//                   <Th
//                     setPrepair={setPrepair}
//                     // row={row}
//                     prepair={prepair}
//                     setLanguageIn={setLanguageIn}
//                   />
//                 </div>
//               </div>
//             }
//           />
//         )}
//       </div>
//     </div>
//   );
// };

const ContextRenderChangeLanguage = ({ text, drawer }) => {
  const [open, setOpen] = React.useState(false);
  const { language, FunctionChangeLanguageTo } =
    React.useContext(ContextLanguage);
  const [prepair, setPrepair] = React.useState(language);
  const isMobile = useIsMobile();
  const [languageIn, setLanguageIn] = React.useState(language);
  const location = useLocation();

  // React.useEffect(() => {
  //   setPrepair(language);
  //   setLanguageIn(language);
  // }, [setPrepair, setLanguageIn, language]);

  return (
    <div className="relative">
      <a
        // href={FunctionChangeHerfLanguage({
        //   language,
        //   location,
        // })}
        onClick={() => {
          // if (FunctionClickIsNotPageSaparate(location)) {
          FunctionChangeLanguageTo(language === "TH" ? "EN" : "TH");
          // }
        }}
        // onClick={(e) => {
        //   e.stopPropagation();
        //   // setOpen(!open);
        //   FunctionChangeLanguageTo(language === "TH" ? "EN" : "TH");
        // }}
        className={`${
          drawer ? "gap-2" : "gap-4"
        } flex  items-center cursor-pointer`}
      >
        {drawer ? (
          CONSTANT_LANGUAGE_IMAGE_DRAWER[language]
        ) : (
          <React.Fragment>
            <div
              style={{
                display: language === "TH" ? "block" : "none",
              }}
            >
              <ICON_ENGLISH className={STYLE_IMG_LANGUAGE} />
            </div>
            <div
              style={{
                display: language === "EN" ? "block" : "none",
              }}
            >
              <ICON_THAI className={STYLE_IMG_LANGUAGE} />
            </div>
          </React.Fragment>
        )}
        {text ? (
          <div
            className={`${
              language === "TH"
                ? "font-Poppins text-sm md:text-base text-laundry-gray-100 md:hover:text-[#3AB4ED] cursor-pointer "
                : " font-NotoSansThai text-sm-th md:text-base-th text-laundry-gray-100 md:hover:text-[#3AB4ED] cursor-pointer mt-1"
            } <30>`}
          >
            {language === "TH" ? "English" : "ไทย"}
          </div>
        ) : (
          ``
        )}
        {isMobile ? (
          <div
            onClick={() => {
              FunctionChangeLanguageTo(language === "TH" ? "EN" : "TH");
            }}
            className={`${
              open ? STYLE_BG_OPACITY_MODAL : STYLE_BG_TRANSPARENT_MODAL
            } ${STYLE_BG_MODAL}`}
          >
            <div
              className={`${
                open ? "h-full inset-0  " : " h-0 w-0 "
              } transition-shadow  duration-500 fixed  `}
            ></div>
          </div>
        ) : (
          <TemplateModal
            classNameSave={`${
              prepair === "TH"
                ? " text-sm-th md:text-base-th "
                : " text-sm md:text-base "
            }`}
            classNameCancel={`${
              prepair === "TH"
                ? " text-sm-th md:text-base-th "
                : " text-sm md:text-base "
            }`}
            classNameModal={`${
              prepair === "TH" ? "font-NotoSansThai" : "font-Poppins"
            } h-modals`}
            acceptText={TEXT_CONFIRM[languageIn]}
            cancelText={TEXT_CANCEL[languageIn]}
            save={() => {
              FunctionChangeLanguageTo(prepair);
            }}
            showCloseButton={true}
            showSaveButton={true}
            open={open}
            setOpen={setOpen}
            panel={
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className={STYLE_PARENT_PANEL_MODAL}
              >
                <div
                  className={`${
                    language === "TH" ? STYLE_HEADING_3_TH : STYLE_HEADING_3
                  } text-center mb-4 h-head_language `}
                >
                  Language • <span className="font-NotoSansThai"> ภาษา</span>
                </div>

                {/* {Object.keys(CONSTANT_LANGUAGE).map((row, i) => {
                  if (row === CONSTANT_LANGUAGE.EN) {
                    return (
                      <div key={`key-of-language-${i}`} className=" space-y-4">
                        <Eng
                          setPrepair={setPrepair}
                          row={row}
                          prepair={prepair}
                          setLanguageIn={setLanguageIn}
                        />
                      </div>
                    );
                  } else if (row === CONSTANT_LANGUAGE.TH) {
                    return (
                      <div key={`key-of-language-${i}`} className=" space-y-4 ">
                        <Th
                          setPrepair={setPrepair}
                          row={row}
                          prepair={prepair}
                          setLanguageIn={setLanguageIn}
                        />
                      </div>
                    );
                  } else {
                    return <React.Fragment />;
                  }
                })} */}
                <div className="">
                  <Eng
                    setPrepair={setPrepair}
                    // row={row}
                    prepair={prepair}
                    setLanguageIn={setLanguageIn}
                  />
                  <Th
                    setPrepair={setPrepair}
                    // row={row}
                    prepair={prepair}
                    setLanguageIn={setLanguageIn}
                  />
                </div>
              </div>
            }
          />
        )}
      </a>
    </div>
  );
};
export default ContextRenderChangeLanguage;
